import { withImageOptimizationQuery } from '@common/utils';
import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useBrandLiabilityCompensationBannerService = () => {
  const param = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(param);
  return {
    parallel_imported_banner_image_url:
      withImageOptimizationQuery(product.parallel_imported_banner_image_url, { format: 'webp', quality: 80 }) ??
      product.parallel_imported_banner_image_url,
  };
};
